<div class="iam-topbar">
  <div class="iam-topbar-left">
    <div class="p-pt-1 p-pl-3">
      <a routerLink="/" title="TTC Invoice">
        <img src="assets/ttc-invoice/T-Invoice-full.png" alt="TTC Invoice" style="height: 4rem">
      </a>
    </div>
  </div>
  <div class="iam-topbar-right">
    <div class="iam-topbar-menu" *ngIf="AuthService.hasRoles(['Customer'])">
      <a pRipple class="iam-topbar-app-link" routerLink="/customer/invoice/hdbh" routerLinkActive="active">
        <img src="assets/icon-app-ttc/icon-app-ttc-invoice.png" alt="Hóa đơn điện tử">
        <span>HÓA ĐƠN<br>ĐIỆN TỬ</span>
      </a>
      <a pRipple class="iam-topbar-app-link" routerLink="/customer/invoice-sync" routerLinkActive="active">
        <img src="assets/icon-app-ttc/icon-app-ttc-qlhd.png" alt="Quản lý hoá đơn đầu vào">
        <span>QUẢN LÝ HÓA ĐƠN ĐẦU VÀO</span>
      </a>
      <a pRipple class="iam-topbar-app-link" [href]="tncnUrl">
        <img src="assets/icon-app-ttc/icon-app-ttc-tncn.png" alt="Quản lý Chứng từ TNCN">
        <span>QUẢN LÝ CHỨNG TỪ TNCN</span>
      </a>
    </div>
    <ul class="iam-topbar-actions">
      <li class="iam-topbar-action" *ngIf="AuthService.hasRoles(['Customer'])">
        <app-package-renewal></app-package-renewal>
      </li>
      <li class="iam-topbar-action">
        <!--        <a pRipple class="p-d-flex p-flex-row p-ai-center" *ngIf="AuthService.hasRoles(['Customer'])" (click)="showProductList()" title="Mua gói">-->
        <!--          <p-button label=" Mua gói" icon="pi pi-shopping-cart" styleClass="p-button-outlined"></p-button>-->
        <!--        </a>-->
        <!--        <a pRipple class="p-d-flex p-flex-row p-ai-center" href="" target="_blank" title="Hỗ trợ trực tiếp">-->
        <!--          <img src="assets/images/zalo-60x60.png" alt="" class="p-mr-3" width="30">-->
        <!--          <span>Hỗ trợ trực tiếp</span>-->
        <!--        </a>-->
        <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="entities.onTopbarActionClick($event, 'ShowSupport')"
          title="Thông tin hotline">
          <img src="assets/images/support.png" alt="" class="p-mr-3" width="30">
          <span class="p-d-flex p-flex-column">
            <span>Hotline hỗ trợ: <b>1900 966 966 - 0969 939 139</b></span>
            <span>Hotline kinh doanh: <b>0868 810 999</b></span>
          </span>
        </a>
        <div *ngIf="entities.activeTopbarAction === 'ShowSupport'" class="iam-topbar-action-panel p-shadow-6 p-p-3">
          <div class="">
            <div class="p-col-12" style="border-bottom: 1px solid #1492e6;">
              <b style="line-height: 20px;display: inline-block;">Thông tin hỗ trợ</b>
            </div>
            <div class="p-col-12 pointer">Hotline hỗ trợ: 1900 966 966 - 0969 939 139</div>
            <div class="p-col-12" style="border-top: 1px solid #1492e6;">
              <b style="line-height: 20px;display: inline-block;">Hotline kinh doanh: 0868 810 999</b>
            </div>
          </div>
        </div>
      </li>
      <li class="iam-topbar-action">
        <p-button
          label="{{ decreeAndCircularUsing === 'DecCir32' ? 'Nâng cấp lên TT78 - NĐ 123/2020/NĐ-CP' : 'Chuyển về TT32 - NĐ51' }}"
          styleClass="p-button-outlined p-button-help p-button-rounded" (onClick)="toggleDecreeCircular()"
          *ngIf="AuthService.hasRoles(['Customer']) && decreeAndCircularUsing === 'DecCir32'"></p-button>
        <a pRipple class="rounded-circle" (click)="entities.onTopbarActionClick($event, 'QuickCreate')"
          title="{{ 'QuickCreate'|translate }}" *ngIf="AuthService.hasRoles(['Customer'])">
          <i class="pi pi-plus-circle pi-large"></i>
        </a>
        <div *ngIf="entities.activeTopbarAction === 'QuickCreate'" class="iam-topbar-action-panel p-shadow-6 p-p-3">
          <div class="p-mb-3">
            <span style="font-size: 20px;">{{ 'QuickCreate'|translate }}</span>
          </div>
          <div class="p-d-flex">
            <div class="p-mr-5" style="width: 140px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{
                    'Invoice'|translate
                    }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/hdbh/create">Hóa đơn bán hàng</div>
              </div>
            </div>
            <div class="p-mr-5" style="width: 140px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{
                    'HandleInvoice'|translate
                    }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/cancelled">Hủy hóa đơn</div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/replaced">Thay thế hóa đơn</div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/adjusted">Điều chỉnh hóa đơn</div>
              </div>
            </div>
            <div class="p-mr-5" style="width: 230px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{
                    'RegisterToIssue'|translate
                    }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/register/invoice-templates/create">Mẫu hóa đơn</div>
                <!--                <div class="p-col-12">Quyết định áp dụng HĐĐT</div>-->
                <div class="p-col-12 pointer" routerLink="/customer/register/release-announcement/create">Thông báo phát
                  hành HĐ
                </div>
                <!--                <div class="p-col-12">Thông báo hủy hóa đơn</div>-->
                <!--                <div class="p-col-12">Thông báo điều chỉnh thông tin HĐ</div>-->
              </div>
            </div>
            <div style="width: 140px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{
                    'Dictionary'|translate
                    }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/category/buyers/create">Khách hàng</div>
                <div class="p-col-12 pointer" routerLink="/customer/category/products/create">Hàng hóa, dịch vụ</div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="iam-topbar-action">
        <a pRipple class="rounded-circle" (click)="entities.onTopbarActionClick($event, 'Profile')"
          title="{{ 'Profile'|translate }}">
          <i class="pi pi-user pi-large"></i>
          <span class="p-ml-2" *ngIf="user">{{ displayName }}</span>
        </a>
        <ul *ngIf="entities.activeTopbarAction === 'Profile'" class="iam-topbar-action-panel p-shadow-6">
          <li class="topbar-menu-item">
            <a pRipple class="topbar-link" (click)="changePassword()">
              <i class="pi pi-unlock"></i>
              <span>{{ 'ChangePassword' | translate }}</span>
            </a>
          </li>

          <li class="topbar-menu-item">
            <a pRipple class="topbar-link logout" (click)="logout()">
              <i class="pi pi-power-off"></i>
              <span>{{ 'Logout' | translate }}</span>
            </a>
          </li>
          <li class="p-pt-2 p-pr-3 p-pl-3 p-text-center">
            <span style="font-size: 12px;color: #616161;">{{ user['partyName'] }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
  <p-dialog header="{{ 'ChangePassword'|translate }}" [(visible)]="changingPassword" [style]="{width: '500px'}"
    [resizable]="false" position="top">
    <p-message severity="info"
      text="Xin quý khách lưu ý, để đảm bảo an ninh tài khoản nên dùng một mật khẩu đầy đủ yếu tố sau: Sử dụng ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường và số."></p-message>
    <div class="p-fluid p-formgrid p-grid p-mt-2">
      <div class="p-field p-col-12">
        <label for="oldPassword">{{ 'Password'|translate }}<span class="required">*</span></label>
        <p-password id="oldPassword" formControlName="oldPassword" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('oldPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPassword">{{ 'NewPassword'|translate }}<span class="required">*</span></label>
        <p-password id="newPassword" formControlName="newPassword" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('newPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPasswordVerify">{{ 'NewPasswordVerify'|translate }}<span class="required">*</span></label>
        <p-password id="newPasswordVerify" formControlName="newPasswordVerify" [toggleMask]="true"
          [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('newPasswordVerify')"></app-validator>
      </div>
    </div>
    <p-message severity="error" [text]="changePasswordError" *ngIf="changePasswordError"></p-message>
    <p-footer>
      <p-button label="{{ 'ChangePassword'|translate }}" icon="pi pi-check" styleClass="p-button-raised" type="submit"
        [disabled]="changePasswordForm.invalid"></p-button>
      <p-button label="{{ 'Close'|translate }}" icon="pi pi-times"
        styleClass="p-button-raised p-button-text p-button-plain" (onClick)="changingPassword=false"></p-button>
    </p-footer>
  </p-dialog>
</form>

<p-dialog header="Danh sách gói dịch vụ" [(visible)]="productList" [style]="{width: '1000px'}" [resizable]="false"
  position="top">
  <p-table [value]="items" [selectionMode]="selectionMode" [(selection)]="selectedItem"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
    <ng-template pTemplate="header">
      <tr>
        <th [width]="40" class="p-text-center">#</th>
        <th [width]="160">{{ 'Mã gói'|translate }}</th>
        <th>{{ 'Tên gói'|translate }}</th>
        <th>{{ 'Số lượng'|translate }}</th>
        <th>{{ 'Đơn giá'|translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-index="rowIndex">
      <tr>
        <td class="p-text-center">{{ (index + 1)|number }}</td>
        <td>{{ rowData['pseudoId'] }}</td>
        <td>{{ rowData['productName'] }}</td>
        <td class="p-text-right">{{ rowData['amountValue'] }}</td>
        <td class="p-text-right">{{ rowData['price']|number }}</td>
        <td>
          <p-tableRadioButton [value]="rowData" *ngIf="selectionMode === 'single'"></p-tableRadioButton>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-footer>
    <p-button label="Thanh toán" icon="pi pi-check" styleClass="p-button-raised"
      (onClick)="doPayment(selectedItem)"></p-button>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times"
      styleClass="p-button-raised p-button-text p-button-plain" (onClick)="productList=false"></p-button>
  </p-footer>
</p-dialog>
<p-dialog header="Quét mã để thanh toán" [(visible)]="displayQR" [style]="{width: '500px', height:'600px'}"
  [resizable]="false" position="top">
  <div *ngIf="paymentDone===false" [style]="{display:'flex', justifyContent:'center',width:'100%'}">
    <img [src]="'data:image/png;base64,' + QRdata" alt="QR Code" />
  </div>
  <div class="container" *ngIf="paymentDone">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="message-box _success">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times"
      styleClass="p-button-raised p-button-text p-button-plain" (onClick)="displayQR=false"></p-button>
  </p-footer>
</p-dialog>
